import { render, staticRenderFns } from "./Onebyone.vue?vue&type=template&id=61a5a508&scoped=true"
import script from "./Onebyone.vue?vue&type=script&lang=js"
export * from "./Onebyone.vue?vue&type=script&lang=js"
import style0 from "./Onebyone.vue?vue&type=style&index=0&id=61a5a508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5a508",
  null
  
)

export default component.exports